var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar-wrapper"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.showLoader)?_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-bar-fill"},[_c('div',{staticClass:"loading-text"},[_vm._v("Lade Buchungen ...")])])]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }